document.addEventListener('DOMContentLoaded', function () {

    //add to cart function just push the variant ID and the quantity
    const ajax_add_to_cart = (variantId, quantity = 1) => {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: variantId,
                quantity: quantity
            },
            dataType: 'json',
            success: function(response) {
                setTimeout(() => {
                    handleFloCartBtn();
                    bundle_atc_status()
                    document.querySelectorAll('.bundle-btn span').forEach(el => {
                        el.style.display = 'inline-block';
                    });
                    document.querySelectorAll('.bundle-btn .mahina-bundle-loader').forEach(bundleEl => {
                        bundleEl.style.display = 'none';
                    });
                }, 2000);
            },
            error: function(xhr, status, error) {
               // console.error('Error adding to cart:', xhr.responseText);
            }
        });
    };

  // Function to get the current cart data
    const getCurrentCart = () => {
        return $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
        });
    };

    // Get current cart data on load
    getCurrentCart().then(cart => {
       // console.log('current cart obj:', cart);  
    }).catch(error => {
       // console.error('Error fetching cart data:', error);
    });

    //get selected variant ID
    const get_variant_id = () => {
       const hidden_variant_id = document.querySelector('.product_selected_variant_id');
       return hidden_variant_id?.getAttribute('value');
    }

    let fullVariantTitle = '';
    let variantTitleFirstPart = '';
    const checkVariantInventory = (variant_id, className) => {
        const variantDataElement = document.getElementById('variant-data-json');
        const allVariants = variantDataElement ? JSON.parse(variantDataElement.textContent) : [];
        const matchingVariant = allVariants.find(variant => variant.id === Number(variant_id));
        if (!matchingVariant) {
            return;{ quantity: 0 };
        }

        const quantity = matchingVariant.inventory_quantity;
        const variantPrice = matchingVariant.price / 100;
        fullVariantTitle = matchingVariant.title;
        
        const variantTitleParts = fullVariantTitle.split('/');

        let variantTitle = variantTitleParts[1]?.trim().toLowerCase();
        variantTitleFirstPart = variantTitleParts[0]?.trim();
        
        if (variantTitle?.startsWith('super')) {
        variantTitle = 'super';
        }

        const variantSelectorMessage = document.querySelectorAll('.bundle-container .selected-absorbency');
        variantSelectorMessage.forEach(variantName => {
            variantName.textContent = variantTitle;
           // variantName.textContent = fullVariantTitle;
        });
        return { 
            quantity: matchingVariant.inventory_quantity,
            variantPrice: variantPrice
         };
      // return {quantity, variantPrice};
    };

    const bundle_atc_status = () => {
        const variant_id = get_variant_id();
        checkVariantInventory(variant_id);
        const availableVariants = checkVariantInventory(variant_id);
        const availableQty = availableVariants.quantity
        
        getCurrentCart().then(cart => {
            const existingVariantInCart = cart.items.find(item => item.variant_id === Number(variant_id));
            let alreadyInCartQty = 0;

            if (existingVariantInCart) {
                alreadyInCartQty = existingVariantInCart.quantity;
            }

            const remainingQty = availableQty - alreadyInCartQty;
            if (remainingQty < 3) {
               // document.querySelector('.bundle-container').classList.add('hidden')
                document.querySelector('.bundle-buy-3').disabled = true;
            } else {
                document.querySelector('.bundle-buy-3').disabled = false;
               // document.querySelector('.bundle-container').classList.remove('hidden')
            }

            if (remainingQty < 5) {
                document.querySelector('.bundle-buy-5').disabled = true;
            } else {
                document.querySelector('.bundle-buy-5').disabled = false;
            }

            if (remainingQty < 7) {
                document.querySelector('.bundle-buy-7').disabled = true;
            } else {
                document.querySelector('.bundle-buy-7').disabled = false;
            }
        }).catch(error => {
            //console.error('Error fetching cart data:', error);
        });
    }

    // on load bundle button disabled
    bundle_atc_status()

    const variantClick = document.querySelectorAll('.new-varaint');
    if (variantClick.length > 0) {
        variantClick.forEach(variantButton => {
            variantButton.addEventListener('click', () => {
                bundle_atc_status()
                const activeNewVariant = document.querySelector('.new-varaint.active');
                if (activeNewVariant) {
                    const variantHTML = `<span class="info-msg info-msg-variant-title">
                    <h5 class="size-selected">Size: <span>${variantTitleFirstPart}</span></h5>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 0C5.61553 0 4.26216 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.00303298 5.6003 -0.13559 7.00777 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.39971 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C14 5.14349 13.2625 3.36301 11.9498 2.05025C10.637 0.737498 8.85652 0 7 0ZM6 9.795L3.5 7.295L4.295 6.5L6 8.205L9.705 4.5L10.503 5.293L6 9.795Z" fill="#FF805F"></path></svg>
                    </span>`
                    document.querySelector('.bundle-container .info-msg').outerHTML = variantHTML;
                }
            });
        });
    }


    const buttons = document.querySelectorAll('.bundle-btn');
    
    if (buttons) {
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const bundleClasses = event.currentTarget.classList;
                const get_Selected_variant_id = get_variant_id();
                const getVariantPrice = checkVariantInventory(get_Selected_variant_id);
                const selector1HasActive = document.querySelector('.mahina_selector_1.active');
                const selector2HasActive = document.querySelector('.mahina_selector_2.active');
                const messageSelector = document.querySelector('.bundle-container .info-msg');
                const product_qty = button.getAttribute('data-product_qty');
                const discountPercentage = button.getAttribute('data-discount_percentage')
                if (!selector1HasActive && !selector2HasActive) {
                    messageSelector.textContent = 'Please select Size and Absorbency'
                    messageSelector.classList.add('warning_msg');
                    return;
                } else if (!selector1HasActive) {
                    messageSelector.textContent = 'Please select Size'
                    messageSelector.classList.add('warning_msg');
                    return;
                } else if (!selector2HasActive) {
                    messageSelector.textContent = 'Please select Absorbency'
                    messageSelector.classList.add('warning_msg');
                    return;
                } else {
                    if (bundleClasses.contains('bundle-buy-3')) {
                        document.querySelectorAll('.bundle-btn.bundle-buy-3 span').forEach(el => {
                            el.style.display = 'none';
                        });
                        document.querySelector('.bundle-btn.bundle-buy-3 .mahina-bundle-loader').style.display = 'flex';
                    } else if (bundleClasses.contains('bundle-buy-5')) {
                        document.querySelectorAll('.bundle-btn.bundle-buy-5 span').forEach(el => {
                            el.style.display = 'none';
                        });
                        document.querySelector('.bundle-btn.bundle-buy-5 .mahina-bundle-loader').style.display = 'flex';
                    } else if (bundleClasses.contains('bundle-buy-7')) {
                        document.querySelectorAll('.bundle-btn.bundle-buy-7 span').forEach(el => {
                            el.style.display = 'none';
                        });
                        document.querySelector('.bundle-btn.bundle-buy-7 .mahina-bundle-loader').style.display = 'flex';
                    }

                    if (messageSelector && messageSelector.classList.contains('warning_msg')) {
                        messageSelector.classList.remove('warning_msg');
                    }
                    const discountNumber = Number(discountPercentage);
                    const quantity = Number(product_qty);
                    const price = Number(getVariantPrice.variantPrice); 
                    const originalPrice = price * quantity;
                    const discountFactor = 1 - (discountNumber / 100);
                    const discountedTotal = (price * quantity) * discountFactor;
                    const finalPrice = discountedTotal.toFixed(2);
                    const discountedAmount = Math.round((originalPrice - finalPrice) * 100) / 100;
                    const priceHTML = `<h3 class="info-msg">
                    <span class="show-price-discount">
                        <span id="sale-price">₹${finalPrice}
                        </span>
                        <span id="original-price">
                            ₹ ${originalPrice}
                        </span>
                        <span class="product-price__item price-label price-label--sale">You Save ₹${discountedAmount} (${discountNumber}% off)</span>
                    </span>
                    </h3>`
                    const allSetText = document.querySelector('.bundle-title-content-wrap')
                    allSetText.textContent = 'All Set! Bundle Price:'
                    messageSelector.outerHTML = priceHTML;
                }

                const selected_variant_id = get_variant_id();
                if (selected_variant_id) {
                    ajax_add_to_cart(selected_variant_id, product_qty);
                } else {
                  //  console.error('No variant ID found');
                }
            });
        });
    }
})